import { render, staticRenderFns } from "./ContactSetting.vue?vue&type=template&id=6150a99c&scoped=true&"
import script from "./ContactSetting.vue?vue&type=script&lang=js&"
export * from "./ContactSetting.vue?vue&type=script&lang=js&"
import style0 from "./ContactSetting.vue?vue&type=style&index=0&id=6150a99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6150a99c",
  null
  
)

export default component.exports